/*
  Bryny · instant add-to-cart feedback (all product pages).
  Adding goes through two server calls in a row (Kaching's bundle add, then the theme's add with the
  pre-selected cart extras), so on a slow phone it can take seconds before the drawer opens.
  This opens the cart drawer the moment Add to cart is tapped, with an "Adding to your cart" state.
  The theme replaces the drawer's content (#CartDrawer) when the cart comes back, which removes the
  loading state by itself. If no add request starts, or the add fails, the drawer closes again.
*/
(() => {
  if (window.bFastAtc) return;
  window.bFastAtc = true;
  if (window.Shopify && Shopify.designMode) return;

  // count add-to-cart requests (Kaching and the theme both use fetch)
  let adds = 0;
  const isAdd = (u) => /\/cart\/add(\.js)?(\?|$)/.test(String(u || ''));
  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input && input.url;
      if (isAdd(url)) adds++;
      return origFetch.apply(this, arguments);
    };
  }
  // Kaching may keep its own copy of fetch, so finished add requests are counted too
  if ('PerformanceObserver' in window) {
    try { new PerformanceObserver((l) => l.getEntries().forEach((en) => { if (isAdd(en.name)) adds++; })).observe({ type: 'resource', buffered: false }); } catch (e) {}
  }
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (isAdd(url)) adds++;
    return origOpen.apply(this, arguments);
  };

  const css = document.createElement('style');
  css.textContent = `
    .b-adding { position: absolute; inset: 0; z-index: 50; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 14px;
      background: #f4ebda; font: 600 16px/1.3 'Inter', system-ui, sans-serif; color: #2a2320; letter-spacing: 0; }
    .b-adding__spin { width: 34px; height: 34px; border-radius: 50%; border: 3px solid rgba(47,74,79,.18); border-top-color: #2f4a4f; animation: b-adding-spin .8s linear infinite; }
    @keyframes b-adding-spin { to { transform: rotate(360deg); } }
    @media (prefers-reduced-motion: reduce) { .b-adding__spin { animation-duration: 2.4s; } }
    cart-drawer.is-empty .drawer__inner > .b-adding, .is-empty .drawer__inner > .b-adding { display: flex !important; }
    .b-adding--preview { justify-content: flex-start; padding: 16px 16px 0; }
    .b-adding--top { padding-top: 64px; }
    .b-adding__card { width: 100%; box-sizing: border-box; display: flex; gap: 12px; align-items: center; padding: 12px; border-radius: 14px; background: #fffaf1; box-shadow: 0 1px 0 rgba(148,97,55,.12); opacity: .92; }
    .b-adding__img { flex: none; width: 64px; height: 64px; border-radius: 10px; object-fit: cover; background: #efe6d6; }
    .b-adding__info { flex: 1; min-width: 0; }
    .b-adding__title { margin: 0; font: 500 16px/1.25 'Fraunces', Georgia, serif; color: #2a2320; }
    .b-adding__sub { margin: 3px 0 0; font: 400 13px/1.35 'Inter', system-ui, sans-serif; color: #5b524b; }
    .b-adding__price { flex: none; font: 600 15px/1 'Inter', system-ui, sans-serif; color: #2a2320; white-space: nowrap; }
    .b-adding__status { display: flex; align-items: center; gap: 10px; font: 600 14px/1.3 'Inter', system-ui, sans-serif; color: #2f4a4f; }
    .b-adding--preview .b-adding__spin { width: 20px; height: 20px; border-width: 2.5px; }`;
  document.head.appendChild(css);

  // What the customer picked, read from the page at the moment they tap (only for the preview card).
  const txt = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
  const choice = (btn) => {
    try {
      const scope = btn.closest('product-info, .product, section') || document;
      // a photo that is already on screen (already downloaded), else the share image
      const shown = [...document.querySelectorAll('.product__media img, media-gallery img, .product-media img')].find((i) => i.complete && i.naturalWidth && i.currentSrc);
      const og = document.querySelector('meta[property="og:image"]');
      const out = { img: shown ? shown.currentSrc : og ? og.content : '', shown: !!shown, title: '', sub: '', price: '' };
      const bar = document.querySelector('.kaching-bundles__bar--selected');
      if (bar) {
        out.title = txt(bar.querySelector('.kaching-bundles__bar-title'));
        out.price = txt(bar.querySelector('.kaching-bundles__bar-price'));
        const gifts = [...bar.querySelectorAll('.kaching-bundles__free-gift')].map((g) => {
          const ours = g.querySelector('.b-kv-name');
          const t = ours ? txt(ours).replace(/\s*included$/i, '') : txt(g.querySelector('.kaching-bundles__free-gift__text'));
          return t.replace(/^\+\s*/, '').replace(/\bfree\b\s*/i, '').trim();
        }).filter(Boolean);
        if (gifts.length) out.sub = '+ ' + gifts.join(' + ') + ', free';
      }
      if (!out.title) {
        const h = scope.querySelector('.product__title h1, .product__title, h1') || document.querySelector('h1');
        const q = scope.querySelector('input[name="quantity"]');
        out.title = (q && +q.value > 1 ? q.value + '× ' : '') + txt(h);
        if (!out.price) out.price = txt(scope.querySelector('.price .price-item--sale, .price .price-item--regular, .price-item'));
      }
      return out.title ? out : null;
    } catch (e) { return null; }
  };
  const previewHTML = (c) => {
    const card = document.createElement('div'); card.className = 'b-adding__card';
    if (c.img) { const i = document.createElement('img'); i.className = 'b-adding__img'; i.alt = ''; i.src = c.shown ? c.img : c.img.replace(/^http:/, 'https:') + (c.img.includes('?') ? '&' : '?') + 'width=160'; card.appendChild(i); }
    const info = document.createElement('div'); info.className = 'b-adding__info';
    const t = document.createElement('p'); t.className = 'b-adding__title'; t.textContent = c.title; info.appendChild(t);
    if (c.sub) { const sb = document.createElement('p'); sb.className = 'b-adding__sub'; sb.textContent = c.sub; info.appendChild(sb); }
    card.appendChild(info);
    if (c.price) { const pr = document.createElement('span'); pr.className = 'b-adding__price'; pr.textContent = c.price; card.appendChild(pr); }
    return card;
  };

  const SUBMIT = 'product-form [type="submit"], [id^="SectionAtcBtn-"], .main-product-atc';
  let busy = false;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest(SUBMIT);
    if (!btn || busy) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('loading')) return;
    if (btn.closest('cart-drawer, .quick-add-modal, quick-add-modal')) return;
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer && drawer.querySelector('#CartDrawer');
    if (!drawer || !inner || typeof drawer.open !== 'function') return;

    const before = adds;
    const sentinel = inner.firstElementChild;
    const picked = choice(btn);
    // let the theme / Kaching start their own submit first
    setTimeout(() => {
      if (sentinel && !sentinel.isConnected) return; // already rendered (very fast connection)
      busy = true;
      const overlay = document.createElement('div');
      overlay.className = 'b-adding';
      overlay.setAttribute('role', 'status');
      overlay.innerHTML = '<span class="b-adding__status"><span class="b-adding__spin" aria-hidden="true"></span><span>Adding to your cart…</span></span>';
      if (picked) { overlay.classList.add('b-adding--preview'); overlay.insertBefore(previewHTML(picked), overlay.firstChild); }
      // the drawer panel (not the backdrop); it sits inside #CartDrawer, so the theme's re-render removes the overlay
      const panel = inner.querySelector('.drawer__inner') || inner;
      if (getComputedStyle(panel).position === 'static') panel.style.position = 'relative';
      panel.appendChild(overlay);
      try { drawer.open(btn); } catch (err) { overlay.remove(); busy = false; return; }
      requestAnimationFrame(() => { // keep the title and close button visible when the cart already had items
        const head = panel.querySelector('.drawer__header');
        if (!drawer.classList.contains('is-empty') && head && head.offsetHeight && overlay.isConnected) overlay.style.top = (head.offsetTop + head.offsetHeight) + 'px';
        else overlay.classList.add('b-adding--top'); // empty cart: no header, leave room at the top
      });

      const started = Date.now();
      const stop = (close) => {
        clearInterval(timer);
        busy = false;
        if (overlay.isConnected) overlay.remove();
        if (close && drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close();
      };
      const timer = setInterval(() => {
        if (!overlay.isConnected) return stop(false); // the theme rendered the new cart
        const waited = Date.now() - started;
        const err = document.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (err && err.offsetParent && err.textContent.trim()) return stop(true); // add failed (e.g. sold out)
        if (adds === before && waited > 6000) return stop(true); // nothing was added (e.g. a choice is missing)
        if (waited > 20000) return stop(false);
      }, 100);
    }, 0);
  }, true);
})();
